import React from 'react';

const CARD_IMG = '/Images/News/openai-gpt-5-5-card.png';

const GPT55Launch = () => (
  <>
    <figure className="news-article-figure news-article-figure--hero">
      <img
        src={CARD_IMG}
        alt="OpenAI wordmark on a dark card background (editorial image for GPT-5.5)."
        loading="lazy"
        decoding="async"
      />
      <figcaption>
        GPT-5.5 launch visuals: wordmark from the{' '}
        <a
          href="https://commons.wikimedia.org/wiki/File:OpenAI_logo_2025.svg"
          target="_blank"
          rel="noopener noreferrer"
        >
          OpenAI 2025 logo
        </a>{' '}
        on Wikimedia Commons (public-domain style wordmark; trademark may still apply), on a
        neutral dark background.
      </figcaption>
    </figure>

    <article className="news-article-body">
      <p className="news-lead">
        On April 23, 2026, OpenAI introduced GPT-5.5 and GPT-5.5 Pro, pitched as its most
        capable general models for professional work: multi-step coding, deep research, data
        analysis, and autonomous use of tools with stronger verification behavior. The release
        lands across ChatGPT, the API, and Codex for paid business tiers, alongside a detailed
        system card describing capability and safety testing.
      </p>

      <h2>What changed versus GPT-5.4</h2>
      <p>
        OpenAI stresses agentic reliability: handling ambiguous specs with less hand-holding,
        planning longer workflows, and completing knowledge work with fewer tokens than prior
        generations on comparable tasks. Enterprise-focused evaluations cited roughly a
        ten-point accuracy lift over GPT-5.4 on internal suites. That kind of gain matters for
        compliance, finance, and document-heavy pipelines.
      </p>

      <h2>Benchmarks the company highlighted</h2>
      <ul>
        <li>
          <strong>GDPval:</strong> Reported ~84.9%. OpenAI describes this as a broad
          professional-task benchmark meant to approximate real office work.
        </li>
        <li>
          <strong>OSWorld-Verified:</strong> Reported ~78.7%. This measures using software like a
          human would (clicking, typing, navigating UIs) under verification.
        </li>
      </ul>
      <p>
        As always, public leaderboard numbers are one slice of the story; latency, cost, and
        behavior on your own data matter more for production.
      </p>

      <h2>Pricing, context, and availability</h2>
      <p>
        API pricing announced with the launch was on the order of $5 per million input tokens
        and $30 per million output tokens, with about a one-million-token context window. That
        puts it in the premium tier where teams expect frontier reasoning but watch spend
        carefully on long outputs.
      </p>

      <h2>Safety and risk classification</h2>
      <p>
        OpenAI paired the launch with red-teaming across cybersecurity and sensitive domains,
        and classified the system under its internal framework at high risk, but not at the
        &quot;critical&quot; tier. That framing matters for regulated buyers deciding where
        human review remains mandatory.
      </p>

      <div className="news-insight-box">
        <h3>The big lesson</h3>
        <p>
          GPT-5.5 is as much a product integration story as a model story: the same weights must
          behave well in ChatGPT, IDE agents, and API pipelines. OpenAI&apos;s emphasis on token
          efficiency and verified computer-use scores shows where paying customers want help:
          automation that holds up without blowing the budget.
        </p>
      </div>
    </article>
  </>
);

export default GPT55Launch;
